import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgInstalledCheckmark = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 39, height: 39, viewBox: "0 0 39 39", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", ref, ...props, children: [
  /* @__PURE__ */ jsx("rect", { x: 1.66406, y: 1.83203, width: 35.6689, height: 35.6689, rx: 17.8345, fill: "#4EBF8B" }),
  /* @__PURE__ */ jsx("rect", { x: 1.66406, y: 1.83203, width: 35.6689, height: 35.6689, rx: 17.8345, stroke: "white", strokeWidth: 3 }),
  /* @__PURE__ */ jsx("path", { d: "M16.7443 26.2803L11.0605 20.5621L13.0929 18.5642L16.7443 22.2156L25.9416 13.0527L27.9395 15.0507L16.7443 26.2803Z", fill: "white" })
] });
const ForwardRef = forwardRef(SvgInstalledCheckmark);
export default ForwardRef;
